module.exports = __webpack_public_path__ + "img/slice-logo-biack.dc48533f.svg";